import Swiper from "swiper";

export default function initCardsBenefitsSlider() {
	const config = {
		slidesPerView: 'auto',
		initialSlide: 0,
		centeredSlides: true,
		autoHeight: true,
		breakpoints: {
			1001: {
				slidesPerView: 3,
				autoHeight: true,
				centeredSlides: false
			}
		},
		pagination: {
			el: '.cards-benefits__slider .swiper-pagination',
			clickable: true,
		}
	}

	const target = document.querySelector('.cards-benefits__slider');
	if(!target) return;

	let cardBenefitsSlider = new Swiper('.cards-benefits__slider', config);

	window.addEventListener('orientationchange', function () {
		if (cardBenefitsSlider && cardBenefitsSlider instanceof Swiper) {
			cardBenefitsSlider.destroy(true, true);

			setTimeout(() => {
				cardBenefitsSlider = new Swiper('.cards-benefits__slider', config);
			}, 100);
		}
	});
}
